import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import { type NextBestAction } from '@post-office/confluence-next-best-action';

import { RovoOnboardingBanner } from './components/rovo-onboarding-banner';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';

const PLACEMENT_LABEL = 'Confluence Rovo onboarding banner';
const MESSAGE_TEMPLATE_ID = 'confluence-rovo-onboarding-banner';

const hydrateStage = async ({
	message,
	request,
}: {
	message: {
		messageInstanceId: string;
		messageTemplateId: string;
		triggerId: string;
		context: unknown;
	};
	request: { logger: { info: (ctx: unknown, msg: string) => void } };
}) => {
	request.logger.info(
		{
			messageInstanceId: message.messageInstanceId,
			messageTemplateId: message.messageTemplateId ?? MESSAGE_TEMPLATE_ID,
			placementLabel: PLACEMENT_LABEL,
		},
		'Rovo onboarding banner hydrated successfully',
	);
	return message.context as MessageTemplateContext;
};

/** Exposed for unit testing the hydrate stage. */
export const __hydrateStageForTest = hydrateStage;

export const MessageBackend = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: (input) => {
			const context = input.message.context as MessageTemplateContext;
			return {
				goalMetadata: {
					primaryGoal: {
						goalId: 'clickthrough',
					},
				},
				nextBestAction: context.nextBestActionType,
			};
		},
	},
	hydrate: {
		validate: assertMessageTemplateContext,
		stage: hydrateStage,
	},
}));

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
};

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			handleOnDismissed,
			onSideNavClick,
		}: MessageFrontendProps) => {
			return (
				<RovoOnboardingBanner
					action={nextBestActionType}
					onPrimaryActionClick={onSideNavClick}
					onDismissClick={handleOnDismissed}
				/>
			);
		},
	},
});
